import React from 'react';
import { SectionDivider } from '../components/SectionDivider';
import { Calendar, Clock, ArrowLeft } from 'lucide-react';
import { BlogCard } from '../components/BlogCard';
interface BlogPostLayoutProps {
  title: string;
  metaDescription: string;
  date: string;
  readTime: string;
  content: React.ReactNode;
  faqs?: {
    q: string;
    a: string;
  }[];
  relatedPosts?: {
    title: string;
    excerpt: string;
    slug: string;
    date: string;
    readTime: string;
  }[];
}
export function BlogPostLayout({
  title,
  metaDescription,
  date,
  readTime,
  content,
  faqs,
  relatedPosts
}: BlogPostLayoutProps) {
  return <div className="min-h-screen bg-[#050505] text-white pt-24" data-id="element-936">
      {/* Back Link */}
      <div className="max-w-3xl mx-auto px-4 md:px-6 mb-8" data-id="element-937">
        <a href="/blog" onClick={e => {
        e.preventDefault();
        window.history.pushState({}, '', '/blog');
        window.dispatchEvent(new PopStateEvent('popstate'));
        window.scrollTo(0, 0);
      }} className="inline-flex items-center text-white/50 hover:text-[#c9a84c] transition-colors" data-id="element-938">
          <ArrowLeft className="w-4 h-4 mr-2" data-id="element-939" />
          Back to Blog
        </a>
      </div>

      {/* Header */}
      <article className="px-4 md:px-6" data-id="element-940">
        <header className="max-w-3xl mx-auto mb-12 text-center" data-id="element-941">
          <h1 className="text-3xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-942">
            {title}
          </h1>
          <div className="flex items-center justify-center space-x-6 text-sm text-white/50" data-id="element-943">
            <div className="flex items-center space-x-2" data-id="element-944">
              <Calendar className="w-4 h-4" data-id="element-945" />
              <span data-id="element-946">{date}</span>
            </div>
            <div className="flex items-center space-x-2" data-id="element-947">
              <Clock className="w-4 h-4" data-id="element-948" />
              <span data-id="element-949">{readTime}</span>
            </div>
          </div>
        </header>

        {/* Content */}
        <div className="max-w-3xl mx-auto prose prose-invert prose-lg prose-headings:text-white prose-headings:mt-12 prose-headings:mb-6 prose-p:mb-6 prose-p:leading-relaxed prose-ul:my-6 prose-li:my-2 prose-a:text-[#c9a84c] hover:prose-a:text-[#b09242] prose-strong:text-white mb-16" data-id="element-950">
          {content}
        </div>

        {/* FAQ Section (Optional) */}
        {faqs && faqs.length > 0 && <div className="max-w-3xl mx-auto mb-16 bg-[#0a0a0a] border border-white/10 rounded-xl p-8" data-id="element-951">
            <h2 className="text-2xl font-bold mb-6" data-id="element-952">
              Frequently Asked Questions
            </h2>
            <div className="space-y-6" data-id="element-953">
              {faqs.map((faq, idx) => <div key={idx} className="border-b border-white/10 pb-4 last:border-0 last:pb-0" data-id="element-954">
                  <h3 className="text-lg font-medium text-[#c9a84c] mb-2" data-id="element-955">
                    {faq.q}
                  </h3>
                  <p className="text-white/70 text-sm" data-id="element-956">{faq.a}</p>
                </div>)}
            </div>
          </div>}

        <SectionDivider data-id="element-957" />

        {/* CTA */}
        <div className="max-w-3xl mx-auto text-center py-12" data-id="element-958">
          <h2 className="text-2xl font-bold mb-4" data-id="element-959">
            Need a Professional Website?
          </h2>
          <p className="text-white/60 mb-8" data-id="element-960">
            Get a custom-built website for your Dublin business for just €249.
          </p>
          <a href="/contact" onClick={e => {
          e.preventDefault();
          window.history.pushState({}, '', '/contact');
          window.dispatchEvent(new PopStateEvent('popstate'));
          window.scrollTo(0, 0);
        }} className="inline-block bg-[#c9a84c] text-black font-bold px-8 py-3 rounded-lg hover:bg-[#b09242] transition-colors" data-id="element-961">
            Get a Quote Today
          </a>
        </div>

        {/* Related Posts */}
        {relatedPosts && relatedPosts.length > 0 && <div className="max-w-6xl mx-auto py-16 border-t border-white/10" data-id="element-962">
            <h2 className="text-2xl font-bold mb-8 text-center" data-id="element-963">
              Related Articles
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-964">
              {relatedPosts.map((post, idx) => <BlogCard key={idx} {...post} data-id="element-965" />)}
            </div>
          </div>}
      </article>
    </div>;
}